module.exports = __webpack_public_path__ + "img/27_63.42337348.png";